import { clozeTextLearnElement_ClozeTextLearnElementFragment$data } from "@relay/clozeTextLearnElement_ClozeTextLearnElementFragment.graphql";
import { stripHtml } from "@utils/strip-html";

export function stripHtmlFromTextParts(
	parts: clozeTextLearnElement_ClozeTextLearnElementFragment$data["parts"],
): clozeTextLearnElement_ClozeTextLearnElementFragment$data["parts"] {
	return parts?.map((part) => {
		if (part.kind === "text" && part?.text) {
			return {
				...part,
				text: stripHtml(part?.text),
			};
		}
		return part;
	});
}
